import { NonProfitOnBoardingPreference } from '@/api/models/meModels';
import { NonProfitOrgType } from '@/api/models/nonProfitOrgModels';
import { NpoOnboardingRoutes } from '@/constants/enums/NpoOnboardingRoutes';

export const npoOnboardingWhereToRoute = (type: NonProfitOrgType, preferences: NonProfitOnBoardingPreference[]) => {
  const whereToRoute =
    !preferences[0]?.isSetPreferenceScreen && !preferences[0]?.skipPreferenceScreen
      ? NpoOnboardingRoutes.PREFERENCES
      : !preferences[0]?.isSetNotificationsScreen
        ? NpoOnboardingRoutes.NOTIFICATIONS
        : !preferences[0]?.isSetLocationScreen
          ? NpoOnboardingRoutes.LOCATION
          : !preferences[0].nineNintyForm && type === 'CHARITIES'
            ? NpoOnboardingRoutes.NINE_NINETY_FORM
            : !preferences[0].general
              ? NpoOnboardingRoutes.GENERAL
              : !preferences[0].revenue
                ? NpoOnboardingRoutes.REVENUE
                : !preferences[0].backgroundChecks
                  ? NpoOnboardingRoutes.BACKGROUND_CHECKS
                  : !preferences[0].boardDirectors
                    ? NpoOnboardingRoutes.BOARD_DIRECTORS
                    : !preferences[0].pastors && type === 'CHURCH'
                      ? NpoOnboardingRoutes.PASTORS
                      : !preferences[0].totalSalaries
                        ? NpoOnboardingRoutes.TOTAL_SALARIES
                        : !preferences[0].pL
                          ? NpoOnboardingRoutes.PROFIT_AND_LOSS
                          : !preferences[0].partyAudit
                            ? NpoOnboardingRoutes.PARTY_AUDIT
                            : !preferences[0].impactStudy
                              ? NpoOnboardingRoutes.IMPACT_STUDY
                              : !preferences[0].salaries
                                ? NpoOnboardingRoutes.SALARIES
                                : !preferences[0].landEquipments
                                  ? NpoOnboardingRoutes.LAND_EQUIPMENTS
                                  : !preferences[0].fundraising
                                    ? NpoOnboardingRoutes.FUNDRAISING
                                    : !preferences[0].programs
                                      ? type === 'CHURCH'
                                        ? NpoOnboardingRoutes.PROGRAMS
                                        : NpoOnboardingRoutes.TOTAL_GRANTS_PROGRAMS
                                      : !preferences[0].lightRatingQuestions
                                        ? NpoOnboardingRoutes.LIGHT_RATING_QUESTIONS
                                        : NpoOnboardingRoutes.PROFILE;

  return whereToRoute;
};
